
<div @click="$emit('click')" class="emoji-item">
  <img v-if="isWindows" :src="getEmojiImageUrl(emoji)" :alt="emoji" :class="sizeClass" />
  <span v-else :class="sizeClass">{{ emoji }}</span>
</div>
